import React, { useEffect, useState } from "react";

const Modal = ({ isOpen, onClose, children, title = "" }) => {
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShowAnimation(true);
    } else {
      setTimeout(() => setShowAnimation(false), 300); // Match the duration of the animation
    }
  }, [isOpen]);

  if (!showAnimation && !isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0"
      }`}
    >
      <div
        className={`bg-white rounded-md shadow-lg w-[95%] sm:w-[85%] md:w-[70%] lg:w-1/3
  max-h-[90vh] flex flex-col p-6 overflow-hidden
  transform transition-transform duration-300 ${
    isOpen ? "scale-100" : "scale-90"
  }`}
      >
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-xl text-primary font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-xl text-red-400 hover:text-gray-700"
          >
            x
          </button>
        </div>
        <div className="overflow-y-auto pr-1">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
